import * as React from 'react';
import { Card, CardContent } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import KYCIcon from '@mui/icons-material/FingerprintOutlined';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import {
  AutocompleteInput,
  FilterList,
  FilterListItem,
  FilterLiveSearch,
  ReferenceInput,
  SavedQueriesList,
} from 'react-admin';
import {
  endOfYesterday,
  startOfWeek,
  subWeeks,
  startOfMonth,
  subMonths,
  startOfToday,
} from 'date-fns';
import { Customer } from '../types';

// import segments from '../segments/data';

const Aside = () => (
  <Card
    sx={{
      display: {
        xs: 'none',
        md: 'block',
      },
      order: -1,
      flex: '0 0 15em',
      mr: 2,
      mt: 6,
      alignSelf: 'flex-start',
    }}
  >
    <CardContent sx={{ pt: 1 }}>
      <FilterLiveSearch hiddenLabel />

      <SavedQueriesList />

      <FilterList label='Account Type' icon={<AccessTimeIcon />}>
        <FilterListItem
          label='Bank'
          value={{
            payeeAccountType: 'Bank',
          }}
        />
        <FilterListItem
          label='UPI'
          value={{
            payeeAccountType: 'Upi',
          }}
        />
      </FilterList>
      <FilterList label='Payee Creation Date' icon={<AccessTimeIcon />}>
        <FilterListItem
          label='Today'
          value={{
            createdAtGTE: startOfToday().toISOString(),
            createdAtLTE: undefined,
          }}
        />
        <FilterListItem
          label='Yesterday'
          value={{
            createdAtGTE: endOfYesterday().toISOString(),
            createdAtLTE: undefined,
          }}
        />
        <FilterListItem
          label='This week'
          value={{
            createdAtGTE: startOfWeek(new Date()).toISOString(),
            createdAtLTE: undefined,
          }}
        />
        <FilterListItem
          label='This month'
          value={{
            createdAtGTE: startOfMonth(new Date()).toISOString(),
            createdAtLTE: undefined,
          }}
        />
      </FilterList>
      <FilterList label='Payee Type' icon={<AccessTimeIcon />}>
        <FilterListItem
          label='Offline'
          value={{
            userId: 'offline',
          }}
        />
      </FilterList>

      {/* <ReferenceInput source="userId" reference="customers">
        <AutocompleteInput
          optionText={(choice?: Customer) =>
            choice?.id // the empty choice is { id: '' }
              ? `${choice?.personalDetails?.firstName} ${choice?.personalDetails?.lastName}`
              : ''
          }
          sx={{ minWidth: 200 }}
        />
      </ReferenceInput> */}
    </CardContent>
  </Card>
);

export default Aside;
